import { ReactNode } from 'react';
import AgentBadge from '@/components/agent-badge';
import { AgentModel } from '@/lib/models/agent.model';

const SystemBadge = (
  agents: AgentModel[],
  agentId?: string
): { BadgeEl: ReactNode; title: string } => {
  const agent = agentId ? agents?.find(({ id }) => id === agentId) : undefined;
  const agentAvailable = !!agent;

  return {
    BadgeEl: <AgentBadge agent={agent} key={`badge-${agentId}`} />,
    title: agentAvailable ? agent.portal.badge.title || 'Assistant' : '<Assistant Unavailable>',
  };
};

export default SystemBadge;
